define('datakit/hal/link.model',['require','exports','module','underscore','backbone.radio','backbone','../model'],function(require, exports, module) {
  var _ = require('underscore');
  var Radio = require('backbone.radio');
  var Backbone = require('backbone');
  var Model = require('../model');

  var LinkModel = Model.extend({

  });

  Radio.channel('models').reply('DataKit.LinkModel', _.constant(LinkModel));

  module.exports = LinkModel;
});

